module.exports = __webpack_public_path__ + "static/media/final-10.69b2a75c.svg";